<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h3>Import Inventory</h3>
    </div>
  </div>

  <hr style="margin-top:2px;margin-bottom:2px" />
    <aims-import
      importType="Inventory"
      configFile="Inventory/GetImportInventoryConfig"
      importUrl="Inventory/ImportInventory">
    </aims-import>

</div>
